import { cn, formatDate } from "@/lib/utils";
import { CaretDown } from "@phosphor-icons/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  date: Date | null;
  setDate: (date: Date | null) => void;
  dateFormat?: string;
  label?: string;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
}

const DateInput = ({
  date,
  setDate,
  dateFormat = "MMM dd, yyyy",
  label,
  placeholder,
  containerClassName,
  className,
  ...props
}: DateInputProps) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLInputElement>(null);

  return (
    <div
      className={cn(
        "relative w-fit rounded-lg border-[1.5px] border-white/10 bg-[#9ED7EC33] shadow-[0px_1px_4px_0px_#00000025]",
        containerClassName
      )}
    >
      <button
        onClick={() => {
          if (ref.current) {
            ref.current.focus();
            ref.current.showPicker();
          }
        }}
        style={{
          background:
            "linear-gradient(161deg, rgba(0, 0, 0, .3) -25%, rgba(0, 0, 0, 0) 27%, rgba(255, 255, 255, 0) 75%, rgba(255, 255, 255, 0.3) 122%)",
        }}
        className="flex w-full flex-row items-center justify-between gap-7 rounded-[7px] py-[7px] pl-[13px] pr-[10px]"
      >
        <div className="flex flex-col items-start gap-2">
          {label && (
            <span className="text-xs font-medium leading-[9px] text-white/60">
              {label}
            </span>
          )}
          <span className="text-sm font-medium leading-[14px] text-white">
            {date
              ? formatDate(date, dateFormat)
              : (placeholder ?? t("label.select_date"))}
          </span>
        </div>
        <CaretDown size={16} weight="bold" color="white" />
      </button>
      <input
        onChange={(e) => {
          setDate(e.target.value ? new Date(e.target.value) : null);
        }}
        ref={ref}
        className={cn(
          "pointer-events-none absolute left-0 top-0 h-full w-full opacity-0",
          className
        )}
        id="starting-date"
        type="date"
        role="textbox"
        {...props}
      />
    </div>
  );
};

export default DateInput;
